import { Component, OnChanges, Input } from '@angular/core';
import { Label, Color } from 'ng2-charts';
import { ChartDataSets } from 'chart.js';
import { FormatService } from '@services/format.service';

import { MonitoringResultGraph } from '@classes/monitoring/monitoring-result-graph';

@Component({
  selector: 'app-monitoring-graph-day',
  templateUrl: './monitoring-graph-day.component.html',
  styleUrls: ['./monitoring-graph-day.component.scss']
})
export class MonitoringGraphDayComponent implements OnChanges {

    @Input() graph: MonitoringResultGraph;

    labels: Label[] = ['0h', '1h', '2h', '3h', '4h', '5h', '6h', '7h', '8h', '9h', '10', '11h',
        '12h', '13h', '14h', '15h', '16h', '17h', '18h', '19h', '20h', '21h', '22h', '23h', '24h'];

    datatimes: number[];

    options = {
        scaleShowValues: true,
        responsive: true,
        elements: {
            line: {
                tension: 0
            },
            point: {
                backgroundColor: "rgba(0, 255, 238,0.28)"
            }
        },
        scales: {
            xAxes: [{
                type: 'time',
                time: {
                    parser: "HH:mm",
                    unit: 'hour',
                    unitStepSize: 2,
                    displayFormats: {
                        'minute': 'HH:mm',
                        'hour': 'HH:mm',
                    },
                    ticks: {
                        min: "00:00",
                        max: "24:00"
                    }
                }
            }],
            yAxes: [{
                stacked: false,
                ticks: {
                    beginAtZero: true,
                    display: true,
                    steps: 30,
                    max: 248.12,
                },
                gridLines: {
                    display: false
                }
            }]
        },
        tooltips: {
            callbacks: {
                label: (tooltipItem: any, data: any) => {
                    const dataset: ChartDataSets = data.datasets[tooltipItem.datasetIndex]; // extraction des données
                    const dataValues: number[] = <number[]>dataset.data;
                    const value: number = dataValues[tooltipItem.index];
                    const total: number = dataValues.reduce((tot, val) => tot + val, 0); // on additionne les données
                    return `${this.formatSrv.formatPercent(value / total)}`; // on transforme les données en %
                }
            },
            bodyFontSize : 12,
        },
    };

    colors: Color[] = [
        {
            borderColor: 'red',
            backgroundColor: 'rgba(143, 30, 30,0.28)'
        }
    ];

    legend = false;
    plugins = [];

    constructor (private formatSrv: FormatService) {}

    ngOnChanges () : void {
        this.datatimes = this.graph.datas.map(data => data.value);

        var options = this.getOptions();
        if (this.graph.maxAxis > 0) {
            options.scales.yAxes[0].ticks.max = this.graph.maxAxis;
        }
        this.options = options;

        if (this.datatimes.length == 24) {
            this.datatimes.push(this.datatimes[0]);
        }
    }

    private getOptions (): any
    {
        return {
            scaleShowValues: true,
            responsive: true,
            elements: {
                line: {
                    tension: 0
                },
                point: {
                    backgroundColor: "rgba(0, 255, 238,0.28)"
                }
            },
            scales: {
                xAxes: [{
                    type: 'time',
                    time: {
                        parser: "HH:mm",
                        unit: 'hour',
                        unitStepSize: 2,
                        displayFormats: {
                            'minute': 'HH:mm',
                            'hour': 'HH:mm',
                        },
                        ticks: {
                            min: "00:00",
                            max: "24:00"
                        }
                    }
                }],
                yAxes: [{
                    stacked: false,
                    ticks: {
                        beginAtZero: true,
                        display: true,
                        steps: 30
                    },
                    gridLines: {
                        display: false
                    }
                }]
            },
            tooltips: {
                callbacks: {
                    label: (tooltipItem: any, data: any) => {
                        const dataset: ChartDataSets = data.datasets[tooltipItem.datasetIndex]; // extraction des données
                        const dataValues: number[] = <number[]>dataset.data;
                        const value: number = dataValues[tooltipItem.index];
                        const total: number = dataValues.reduce((tot, val) => tot + val, 0); // on additionne les données
                        return `${this.formatSrv.formatPercent(value / total)}`; // on transforme les données en %
                    }
                },
                bodyFontSize : 12,
            },
        };
    }

}
